import { gql } from "@apollo/client";

export const GET_ORDER_QUERY = gql(`
  query GET_ORDER(
    $orderNumber: String!
    $isRefillOrder: Boolean
    $isReorder: Boolean
    $isAutofill: Boolean
    $selectedLineItemCategories: [ProductCategory!]
    $formDepartmentId: Int
  ) {
    providerReferral(
      orderNumber: $orderNumber
      isRefillOrder: $isRefillOrder
      isReorder: $isReorder
      isAutofill: $isAutofill
      selectedLineItemCategories: $selectedLineItemCategories
      formDepartmentId: $formDepartmentId
    ) {
      id
      createdAt
      selfPay
      isMedicareBlockingEligible
      isHighCostFlaggingEligible
      isFaxOrder
      insuranceType
      workersCompInfo {
        insuranceName
        caseManagerName
        claimNumber
        caseManagerPhone
        claimAddress
        dateOfAccident
      }
      autoInsuranceInfo {
        insuranceName
        caseManagerName
        claimNumber
        caseManagerPhone
        claimAddress
        dateOfAccident
        stateOfAccident
      }
      insuranceInfo {
        primaryInsuranceType
        primaryInsurance
        primaryPolicyNumber
        primaryGroupNumber
        secondaryInsurance
        secondaryPolicyNumber
        secondaryGroupNumber
      }
      encounterDate
      orderNote
      transcriptionInternalNote {
        id
        note
      }
      orderDocuments {
        s3Documents {
          id
          key
          fileName
          documentType
          opsUserName
        }
        faxes {
          filename
          newOrder
          patientDemographics
          progressNotes
          progressNotesResponse
          otherFiles
          correctedOrder
          opsUserName
        }
      }
      orderStatus
      orderStatusUpdatedAt
      patientDob
      patientEmailAddress
      gender
      patientAddress {
        address1
        address2
        city
        stateName
        zipcode
      }
      clinicDelivery {
        address {
          address1
          address2
          city
          stateName
          zipcode
        }
        phone
        deliveryInstructions
      }
      careCoordinatorEmail
      careInternalId
      careMco
      clinicInfo {
        hospitalName
        departmentName
        departmentId
        departmentType
        address1
        address2
        city
        stateAbbr
        zipcode
        phone
        fax
      }
      signerInfo {
        signerName
        signerDegree
        signerEmails
        signatureTime
        signatureTimezone
        npiNumber
        practices {
          id
          phone
        }
        missingSignatureInfo {
          count
          shouldShowWarning
          shouldBlockOrders
        }
      }
      reorderNumber
      signatureRequestedFromSignerId
      collectShipInfo
      bundledOrder
      assigned
      allowedToEdit
      signNow
      spreeOrder {
        id
        phoneNumber
        secondaryPhoneNumber
        number
        shippingAddress {
          address1
          address2
          city
          stateName
          zipcode
        }
        userId
        patientName
        traceId
        progressNoteExtractionUsed
      }
      woundOrder {
        woundCareLineItems {
          createdAt
          durationOfUse
          frequencyOfUse
          id
          productName
          productNameFromFax
          formItemId
          quantity
          calculatedSizeData {
            quantity
            woundIds
          }
          size {
            id
            name
          }
          sendSmallerSize
          updatedAt
          woundId
          sizePreferenceId
          frequencyPreferenceId
          woundPreferenceId
          substitutionPreferenceId
          disableQuantityAutocalculationDefaultQuantity
          displayUnitLabel
        }
        wounds {
          amountExudate
          description
          dimensionLength
          dimensionWidth
          dimensionDepth
          id
          location
          departmentOrderId
          thickness
          debrided
        }
      }
      compressionOrder {
        compressionPlanOfCare {
          compressionLevelWrapStocking,
          leftAnkle,
          leftCalf,
          legLeftLength,
          thighLeftLength,
          rightAnkle,
          rightCalf,
          legRightLength,
          thighRightLength,
          rightFootCircumference,
          rightFootLength,
          rightFootShoeSize,
          leftFootCircumference,
          leftFootLength,
          leftFootShoeSize,
          compressionLevelSleeve,
          leftHand,
          leftWrist1,
          leftWrist2,
          leftElbow,
          leftUpperArm,
          armLeftLength,
          rightHand,
          rightWrist1,
          rightWrist2,
          rightElbow,
          rightUpperArm,
          armRightLength,
          compressionBraBandSize
        }
        diagnoses {
            diagnosis,
            code
        }
        compressionLineItems {
          productName
          formItemOptionIds
          formItemOptionNames
          formItemId
          subCategory
          quantity
          side
          colorId
        }
      }
      urologyOrder {
        startDate
        lengthOfNeedLifetime
        lengthOfNeedOther
        lengthOfNeedOtherMonths
        utiHistory
        latexAllergy
        ensuresisF980
        neuromuscularN319
        retentionR339
        nephrostomyZ436
        primaryCasualDiagnosis
        urologyLineItems {
          productName
          formItemId
          checkboxAttributes {
            straight
            coude
            hydrophilic
            silicone
            redRubber
            pvc
            twoWay
            threeWay
            latex
            withBag
            withoutBag
            packets
            tube
            regular2000ml
            large4000ml
            balloon5ml
            balloon10ml
            balloon30ml
          }
          brandPreference
          frenchSizeLength
          frequencyOfUse
          qtyMo
        }
      }
      ostomyOrder {
        startDate
        lengthOfNeedLifetime
        lengthOfNeedOther
        lengthOfNeedOtherMonths
        latexAllergy
        z933Colostomy
        z936Urostomy
        z932Ileostomy
        primaryDiagnosisOtherActive
        primaryDiagnosisOther
        colonCancer
        ulcerativeColitis
        perforatedBowel
        bladderCancer
        crohnsDisease
        bowelObstruction
        secondaryDiagnosisOtherActive
        secondaryDiagnosisOther
        additionalJustification
        ostomyLineItems {
          productName
          formItemId
          checkboxAttributes {
            drain
            closed
            urostomy
            oneInch
            twoInch
            fourInch
            pectinTwoOz
            karayaFourHalfOz
            bottle
            bagTwoThousandCc
            medium
            large
            paper
            pink
            cloth
          }
          brandPreference
          productNum
          dailyFrequencyOfUse
          qtyMo
        }
      }
      cpapOrder {
        machineType
        makeAndModel
        cpapPressure
        autoCpapPressureMin
        autoCpapPressureMax
        autoCpapExpiratoryRelief
        autoCpapRampTime
        autoCpapStartingPressure
        bilevelIpap
        bilevelEpap
        autoBilevelPressureSupport
        autoBilevelMaxIpap
        autoBilevelMinEpap
        bipapStMaxIpap
        bipapStMinEpap
        bipapStPressureSupportMin
        bipapStPressureSupportMax
        bipapStBackupRate
        bipapStRampTime
        usesOxygen
        nocturnalOxygen
        humidifierType
        maskType
        existingSizeAndModel
        noseToChin
        noseWidth
        noseLength
        lengthOfNeedType
        lengthOfNeedMonths
        hadCpapLast5Years
        priorCpapReason
        ahiRdiQualifyingOption
        ahiRdiSymptoms
        initialConsultDate
        sleepStudyDate
        followUpEncounterDate
        hadBilevelLast5Years
        priorBilevelReason
        bilevelQualifyingStatement
        noSleepApneaEvidence
        bilevelTestsPerformed
        bilevelOximetryConfirmed
        bilevelBloodGasConfirmed
        cpapDiagnoses {
          id
          diagnosis
          icd10Code
        }
        cpapLineItems {
          productName
          formItemId
          hcpcsCode
        }
      }
      ventilatorOrder {
        ventilatorType
        interfaceType
        maskNoseToChinCm
        chestShellWeightLb
        chestShellCircumferenceCm
        tracheostomyInnerDiameterMm
        tracheostomyOuterDiameterMm
        tracheostomyLengthMm
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        hasQualifyingCondition
        conditionNarrative
        isPrimarilyCpapOrBilevel
        preferredDmeCompany
        ventilatorDiagnoses {
          id
          diagnosis
          icd10Code
        }
        ventilatorLineItems {
          id
          productName
          hcpcsCode
          size
          quantity
        }
      }
      nebulizerOrder {
        compressorType
        otherCompressor
        administrationSetType
        noseToChinCm
        tracheostomyInnerDiameterMm
        tracheostomyOuterDiameterMm
        tracheostomyLengthMm
        includesDisposableFilter
        includesDisposableNebulizerSet
        medication
        otherMedication
        usesSterileSalineOrWater
        dosingInstructions
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        currentlyUsesNebulizer
        currentNebulizerDevice
        otherCurrentNebulizerDevice
        phIsSecondaryToVenousOrRespiratory
        pahIsPrimary
        pahHasQualifyingSecondaryCause
        pahProgressedDespiteTreatment
        pahMeetsPressureThreshold
        pahHasSignificantSymptoms
        pahCalciumChannelBlockersExhausted
        ildConfirmedByHrct
        ildMeetsPressureThreshold
        ildMeetsWedgePressureThreshold
        ildMeetsVascularResistanceThreshold
        ildHasSignificantSymptoms
        hasDocumentedThickSecretions
        alreadyHasCoveredCompressor
        nebulizerDiagnoses {
          id
          diagnosis
          icd10Code
        }
        nebulizerLineItems {
          id
          productName
          hcpcsCode
          size
          quantity
        }
      }
      wheelchairsAndScootersOrder {
        deviceType
        otherDeviceDescription
        powerWheelchairClass
        powerWheelchairSeating
        wheelchairHeight
        seatDepth
        wheelchairSeatWidth
        scooterSeatWidth
        scooterWheels
        scooterSwivelSeat
        scooterSteeringHandle
        patientHeightFeet
        patientHeightInches
        patientWeightLbs
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        dischargeDatetime
        preferredDmeCompany
        deliveryLocationType
        # The Progress Note's medical-necessity interview reads these; a missing
        # field reads as never asked. Keep in sync with ProviderOrderListQueries.tsx.
        weightWithinCapacity
        hadWheelchairPast5Years
        newWheelchairReason
        newWheelchairReasonCategory
        priorDeliveryDate
        priorHcpcsCode
        adlDifficulties
        caneOrWalkerWouldResolve
        mradlBenefits
        selfPropelCapable
        caregiverAvailableToPropel
        homeAccommodatesDevice
        consentToUseDevice
        povTransferAndOperateCapable
        povCognitionAndVisionAdequate
        pwcOperateIndependently
        pwcCaregiverCanOperate
        altDriveControlRequired
        tiltOrReclineQualifies
        tiltAndReclineQualifies
        ventilatorMounted
        specialtyEvaluationCompleted
        neuroEtiology
        expectedToGrow
        selfPropellingPastYear
        mobilityLimitationReasons
        wheelchairsAndScootersDiagnoses {
          id
          diagnosis
          icd10Code
        }
        wheelchairsAndScootersLineItems {
          id
          formItemId
          productName
          hcpcsCode
          size
          quantity
        }
      }
      diabetesOrder {
        bgmSystem
        bgmIsInitialOrder
        cgmSystem
        cgmIsInitialOrder
        cgmSensorType
        pumpSystem
        pumpIsInitialOrder
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        currentlyOnCgmTherapy
        treatedWithInsulin
        hypoglycemicEventHistory
        insulinTreatmentType
        mdiInjectionsPerDay
        smbgTestsPerDay
        cPeptideNgMl
        cPeptideLabLowerLimitNgMl
        fastingBloodSugarMgDl
        hasRenalInsufficiency
        positiveBetaCellAutoantibody
        completedDiabetesEducationProgram
        onMdiWithSelfAdjustments6Months
        glucoseTestsPerDayPrior2Months
        cgmDocumentationOnFile
        mdiQualifyingConditions
        usedPumpBeforeMedicare
        glucoseTestsPerDayBeforeMedicare
        preferredDmeCompany
        diabetesDiagnoses {
          id
          diagnosis
          icd10Code
          qualifyingGroups
        }
        diabetesLineItems {
          id
          formItemId
          productName
          hcpcsCode
          sizeId
          size
          quantity
          remarks
          section
        }
      }
      woundSuctionOrder {
        isTherapyInitiatedInpatient
        machineType
        canisterType
        otherCanister
        includesWoundFiller
        includesAdhesiveDrape
        includesSuctionPad
        includesFoam
        includesSorbactDressing
        isContinuingExistingTherapy
        therapyStartDate
        exceededMaxDressingKits
        excessDressingKitsJustification
        exceededMaxCanisterSets
        hasLargeVolumeDrainageDocumentation
        hasNecroticTissueWithEschar
        hasUntreatedOsteomyelitis
        hasCancerInWound
        hasOpenFistula
        ulcerType
        dressingsAppliedForMoistEnvironment
        patientTurnedAndPositioned
        usedGroup2Or3SupportSurface
        moistureAndIncontinenceManaged
        onDiabeticManagementProgram
        footPressureReduced
        compressionConsistentlyApplied
        encouragedToAmbulateAndElevate
        npwtIsBestAvailableOption
        hasSurgicalOrTraumaticWoundComplication
        needsAcceleratedGranulation
        preferredDmeCompany
        woundSuctionTreatments {
          id
          selectedWoundIndices
          durationOfUse
          frequencyOfChange
        }
        woundSuctionLineItems {
          id
          productName
          hcpcsCode
          quantity
        }
      }
      shellFormOrders {
        id
        productCategory
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        preferredDmeCompany
        meetsMedicalNecessity
        diagnoses {
          id
          diagnosis
          icd10Code
        }
        lineItems {
          id
          productCategory
          productName
          sizeOrSpecifications
          quantity
          remarks
          formItemId
        }
      }
      offTheShelfOrthoticsOrder {
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        offTheShelfOrthoticsDiagnoses {
          id
          diagnosis
          icd10Code
        }
        offTheShelfOrthoticsLineItems {
          id
          formItemId
          productName
          hcpcsCode
          size
          sizeWithMeasurements
          laterality
          waistCircumferenceInches
          chestCircumferenceInches
          forearmCircumferenceInches
          wristCircumferenceInches
          thighCircumferenceInches
          calfCircumferenceInches
          legCircumferenceAboveKneeInches
        }
      }
      customOrthoticsOrder {
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        headNeckSpineSpecifications
        upperLimbSpecifications
        lowerLimbSpecifications
        kneeBracesSpecifications
        feetSpecifications
        patientWeightLbs
        patientAgeYears
        shoeSize
        shoeWidth
        documentsWhyPrefabricatedInsufficient
        isAmbulatory
        spinalTreatmentGoals
        hasRecentKneeInjuryOrSurgery
        hasLigamentousInstability
        hasOaPainOrMobilityLoss
        orthosisProvidesVarusValgusAdjustment
        isWillingToUseKneeOrthosis
        orthosisBenefitsFunctionality
        requiresAnkleFootStabilization
        requiresKneeStabilization
        afoCustomFabricationCriteria
        depthShoeCannotAccommodateDeformity
        preferredDmeCompany
        customOrthoticsDiagnoses {
          id
          diagnosis
          icd10Code
          # Resolved by the backend. An edit only mounts the tab the user opens,
          # so the form's own coverage query cannot be relied on to stamp these.
          qualifyingGroups
        }
        customOrthoticsLineItems {
          id
          formItemId
          systemKey
          region
          productName
          hcpcsCode
          bodyParts
          laterality
          jointType
          quantity
          isMaximumAllowedQuantity
        }
      }
      prostheticsOrder {
        functionalLevel
        isLifetimeLengthOfNeed
        lengthOfNeedInMonths
        isMotivatedToAmbulate
        hasUndergoneMastectomy
        hasOwnedBreastProsthesis
        hasOwnedSameProsthesisType
        isPreviousProsthesisLostOrDamaged
        hasConditionChangeForNewType
        conditionChangeDescription
        hasReceivedPermanentProsthesis
        isGarmentAlternativeToBra
        hasCoveredFormForBraPocket
        diabeticFootConditions
        isDiabetesUnderComprehensivePlanOfCare
        needsDiabeticShoes
        mastectomyAmputationSite
        mastectomyBandSize
        mastectomyCupSize
        lowerLimbRightAmputationSite
        lowerLimbRightCircumference
        lowerLimbRightAttachmentMechanism
        lowerLimbLeftAmputationSite
        lowerLimbLeftCircumference
        lowerLimbLeftAttachmentMechanism
        toeFillersWeight
        toeFillersAge
        toeFillersShoeSize
        toeFillersShoeWidth
        toeFillersLeftToesMissing
        toeFillersRightToesMissing
        preferredDmeCompany
        prostheticsDiagnoses {
          id
          diagnosis
          icd10Code
          qualifyingGroups
        }
        prostheticsLineItems {
          id
          subcategory
          formItemId
          systemKey
          productName
          hcpcsCode
          size
          quantity
          remarks
        }
      }
      careBridgeOrder {
        id
        patientHeightFeet
        patientHeightInches
        patientWeight
        careBridgeLineItems {
          id
          productName
          productType
          productTypeId
          quantity
          sku
          lengthOfNeedLifetime
          lengthOfNeedOther
          lengthOfNeedMonths
          isPurchaseOrderItem
        }
        additionalDiagnosisInfo
      }
      miscellaneousOrder {
        diagnoses {
          id
          diagnosis
          icd10Code
        }
        lineItems {
          id
          productName
          sizeSpecification
          quantity
          remarks
        }
      }
      telehealthOrder {
        selectedItemNames
      }
      planOfCares {
        id
        categoryId
        isPatientOnCgmTherapy
        smbgPerDay
        injectionsPerDay
        insulinTreatmentType
        isPatientOnInsulin
        lengthOfNeedInMonths
        patientHeightFeet
        patientHeightInches
        patientWeight
        oxygenAdditionalSpecifications
        oxygenConservingDeviceSetAt
        oxygenContinuousOptions
        oxygenHasHypoxiaSymptoms
        oxygenHypoxiaImprovesWithO2Confirmed
        oxygenLengthOfNeedMonths
        oxygenLengthOfNeedType
        oxygenMethod
        oxygenPatientMobileInHome
        oxygenPerMinute
        oxygenPo2MmHg
        oxygenPortableType
        oxygenPo2Measurements {
          continuous { roomAir }
          nocturnal { awake asleep baselineAsleep }
          exercise { roomAirPre roomAirDuring onO2Post }
        }
        preferredDmeCompany
        oxygenPrescription
        oxygenRespiratoryTestingDate
        oxygenSpo2Measurements {
          continuous { roomAir }
          nocturnal { awake asleep baselineAsleep }
          exercise { roomAirPre roomAirDuring onO2Post }
        }
        oxygenSpo2Percent
        oxygenTestPerformedMethods
        oxygenTestType
        oxygenTypes
        mobilityLimitedWithoutWheelchair
        mobilityRelatedActivitiesOfDailyLiving
        difficultyWithMobilityLimitation
        mobilityLimitationImpact
        crutchesCanesAndWalkersAloneInsufficient
        homeAssessmentConditions
        patientHasConsented
        walkerConfirmation
        wheelchairConfirmation
        wheelchairLastXYears {
          value
          years
          reason {
            value
            isCustom
          }
        }
        # Hospital Bed Plan of Care fields
        symptomsFromDiagnosis {
          value
          isCustom
        }
        hospitalBedRequirementReason {
          values {
            value
            isCustom
          }
          tractionFrameType {
            value
            isCustom
          }
          tractionEquipmentRequiredReason {
            value
            isCustom
          }
        }
        variableHeightBedConditions {
          injuriesToLowerExtremity {
            value
            isCustom
          }
          severeArthritis {
            value
            isCustom
          }
          severeCardiacConditions {
            value
            isCustom
          }
          spinalCordInjuryOrNeurologicalImpairment {
            value
            isCustom
          }
          limbAmputations {
            value
            isCustom
          }
          functionalAndSupportNeeds {
            value
            isCustom
          }
          other {
            value
            isCustom
          }
        }
        electricBedRequirement {
          value
          isCustom
        }
        patientControlCriteria {
          traumaticBrainInjuryDiagnoses {
            icd10Code
            description
            isCustom
          }
          brainDamageDiagnoses {
            icd10Code
            description
            isCustom
          }
          patientCanOperateControls
        }
        group2SupportSurfaceCriteria {
          surgicalDate
          dischargeDate
          group2SupportSurfacePriorToDischarge
        }
        carePlanEstablished
        supportSurfaceCoverageCriteria {
          icd10ForImmobile {
            value
            isCustom
          }
          doesThePatientHaveTheseConditions {
            value
            isCustom
          }
          icd10ForTheseConditions {
            value
            isCustom
          }
          values {
            value
            isCustom
          }
        }
        pressureUlcerLocationStage {
          location
          sizeL
          sizeW
          sizeD
          stage
          thickness
        }
        trapezeBarRequirement {
          value
          isCustom
        }
        liftRequirement {
          value
          isCustom
        }
        hospitalBedLastXYears {
          value
          reason {
            value
            isCustom
          }
        }
        dischargeDatetime
        deliveryLocationType
      }
      diagnoses {
        id
        categoryDiagnosisTypeId
        icd10DescriptionId
        customIcd10Description
        customIcd10Code
      }
      modernLineItems {
        id
        categoryId
        formItemVariantId
        formItemName
        formItemOptions
        customProductName
        cansPerDay
        bottlesPerMonth
        pumpRateMlPerHour
        pumpHours
        referenceNumber
        quantity
        quantityIsMaximum
        hcpcsCode
      }
      patientWillPayOop
      selectedPracticeIds {
        practiceId
      }
    }
  }
`);

export const UPDATE_ORDER_QUERY = gql(`
  mutation UPDATE_ORDER(
    $providerReferral: ProviderReferralInput!
    $signerInput: SignerInput!
    $hospitalName: String
  ) {
    updateProviderReferral(
      providerReferralInput: $providerReferral
      signerInput: $signerInput
      hospitalName: $hospitalName
    ) {
      spreeOrder {
        number
      }
    }
  }
`);

export const UPDATE_DRAFT_QUERY = gql(`
  mutation UpdateProviderReferralDraft(
    $providerReferral: ProviderReferralInput!
    $signerInput: SignerInput!
    $orderDocuments: [Upload!]
  ) {
    updateProviderReferralDraft(
      providerReferralInput: $providerReferral
      signerInput: $signerInput
      orderDocuments: $orderDocuments
    )
  }
`);

export const UPDATE_AND_SIGN_ORDER_QUERY = gql(`
  mutation UPDATE_AND_SIGN_ORDER($providerReferral: ProviderReferralInput!) {
    updateAndSignProviderReferral(providerReferralInput: $providerReferral) {
      spreeOrder {
        number
      }
    }
  }
`);

export const CREATE_ORDER_QUERY = gql(`
  mutation CREATE_ORDER(
    $providerReferral: ProviderReferralInput!
    $s3DocumentReferences: [S3DocumentReference!]!
    $signerInput: SignerInput!
    $hospitalName: String
    $isOrderFromDraft: Boolean!
    $partnerOrderSubmission: PartnerOrderSubmissionInput
  ) {
    createProviderReferral(
      providerReferralInput: $providerReferral
      s3DocumentReferences: $s3DocumentReferences
      signerInput: $signerInput
      hospitalName: $hospitalName
      isOrderFromDraft: $isOrderFromDraft
      partnerOrderSubmission: $partnerOrderSubmission
    )
  }
`);

export const GET_ADDITIONAL_WOUND_PRODUCTS = gql(`
  query GET_ADDITIONAL_WOUND_PRODUCTS($subcategory: String!) {
    readWoundSubcategoryFormItems(subcategory: $subcategory) {
      createdAt
      durationOfUse
      frequencyOfUse
      id
      productName
      formItemId
      quantity
      size {
        id
        name
      }
      updatedAt
      woundId
      productNameFromFax
      displayUnitLabel
    }
  }
`);

export const GET_WARNING_MESSAGES = gql(`
  query GET_ROW_VALIDATION_WARNING_MESSAGES(
    $woundProductRow: [WoundCareLineItemInput!]!
    $wounds: [WoundInput!]!
    $isMedicareBlockingEligible: Boolean!
    $payor: String
    $insuranceType: String
    $stateName: String
    $departmentId: Int
  ) {
    validationWarningMessagesForAllLineItems(
      woundProductRow: $woundProductRow
      wounds: $wounds
      isMedicareBlockingEligible: $isMedicareBlockingEligible
      payor: $payor
      insuranceType: $insuranceType
      stateName: $stateName
      departmentId: $departmentId
    ) {
      warnings {
        heading
        message
        details
        key
        empty
        error
        formItemId
        woundIndex
        maxAllowedQuantity
      }
    }
  }
`);

export const ALL_WOUND_CARE_FORM_ITEMS = gql(`
  query ALL_WOUND_CARE_FORM_ITEMS {
    allWoundCareFormItems {
      name
      id
      disableQuantityAutocalculationDefaultQuantity
      woundSizeAgnostic
      displayUnitLabel
      isBordered
      popularity
      dressingCategory
    }
  }
`);

/**
 * The ICD-10 to LCD L33370 coverage group mapping, loaded once with the form.
 *
 * The Nebulizer medical-necessity interview re-routes the instant a diagnosis
 * is ticked, so it needs the whole table in hand rather than a lookup per
 * change. 215 codes, and it only moves when CMS revises the LCD.
 */
export const GET_NEBULIZER_QUALIFYING_DIAGNOSIS_CODES = gql(`
  query GET_NEBULIZER_QUALIFYING_DIAGNOSIS_CODES {
    nebulizerQualifyingDiagnosisCodes {
      icd10Code
      qualifyingGroups
    }
  }
`);

/**
 * The medical-necessity decision tree for one form, loaded once with it.
 *
 * The graph itself lives on the backend -- this is the only place the coverage
 * rules are written down -- and the browser walks whatever it is handed. Fetched
 * whole rather than a step at a time because a round trip per click would sit
 * between the provider answering and the next question appearing.
 */
/**
 * The ICD-10 codes that support each LCD coverage group, for Custom Orthotics.
 *
 * Served rather than mirrored: the form's diagnosis-driven steps route on these,
 * and a checked-in copy could disagree with the deployed backend.
 */
export const GET_CUSTOM_ORTHOTICS_QUALIFYING_CODES = gql(`
  query GET_CUSTOM_ORTHOTICS_QUALIFYING_CODES {
    customOrthoticsQualifyingDiagnosisCodes {
      icd10Code
      qualifyingGroups
    }
  }
`);

export const GET_DIABETES_QUALIFYING_CODES = gql(`
  query GET_DIABETES_QUALIFYING_CODES {
    diabetesQualifyingDiagnosisCodes
  }
`);

export const GET_PROSTHETICS_QUALIFYING_CODES = gql(`
  query GET_PROSTHETICS_QUALIFYING_CODES {
    prostheticsQualifyingDiagnosesByLcd {
      lcdCode
      icd10Code
      qualifyingGroup
    }
  }
`);

export const GET_MEDICAL_NECESSITY_INTERVIEW = gql(`
  query GET_MEDICAL_NECESSITY_INTERVIEW($category: ProductCategory!) {
    medicalNecessityInterview(category: $category) {
      entryStepId
      steps {
        stepId
        text
        field
        source
        help
        onUnanswered {
          stepId
          outcome {
            kind
            reason
          }
        }
        routes {
          key
          target {
            stepId
            outcome {
              kind
              reason
            }
          }
        }
        narratives {
          key
          text
        }
      }
    }
  }
`);

export const GET_FORM_ITEM_FREQUENCY_RULES = gql(`
  query GET_FORM_ITEM_FREQUENCY_RULES($formItemId: Int!, $payorName: String) {
    formItemFrequencyRules(formItemId: $formItemId, payorName: $payorName) {
      frequencyOfUse
      coverageDetail {
        heading
        message
        details
        key
      }
    }
  }
`);

export const RECORD_MEDICARE_PATIENT_ON_HHA = gql(`
  mutation RECORD_MEDICARE_PATIENT_ON_HHA(
    $patientDob: String!
    $departmentId: Int!
  ) {
    recordMedicarePatientOnHha(
      patientDob: $patientDob
      departmentId: $departmentId
    )
  }
`);

export const GET_PROVIDER_SIGNERS = gql(`
  query GET_PROVIDER_SIGNERS(
    $departmentId: Int!
  ) {
    providerSigners(
      departmentId: $departmentId
    ){
      id
      name
      npiNumber
      emails
      isHeld
      practices {
        id
        name
        fax
        phone
      }
    }
  }
`);

export const GET_PROVIDER_SIGNER = gql(`
  query GET_PROVIDER_SIGNER(
    $accessToken: String!
    $orderNumber: String!
    $email: String!
  ) {
    providerSigner(
      accessToken: $accessToken
      orderNumber: $orderNumber
      email: $email
    ){
      id
      name
      npiNumber
      emails
      practices {
        id
        name
        fax
        phone
      }
    }
  }
`);

export const GET_PRESIGNED_S3_URLS = gql(`
  query GetPresignedS3Urls($keys: [String!]!) {
    presignedS3Urls(keys: $keys)
  }
`);

export const CREATE_ORDER_DRAFT = gql(`
  mutation CreateOrderDraft(
    $providerReferral: ProviderReferralInput!
    $s3DocumentReferences: [S3DocumentReference!]!
    $signerInput: SignerInput!
    $hospitalName: String
  ) {
    createProviderReferralDraft(
      providerReferralInput: $providerReferral
      s3DocumentReferences: $s3DocumentReferences
      signerInput: $signerInput
      hospitalName: $hospitalName
    )
  }
`);

export const GET_DEPARTMENT_ORDER_PREFERENCES = gql(`
  query GET_DEPARTMENT_ORDER_PREFERENCES($departmentId: Int!) {
    departmentOrderPreferences(departmentId: $departmentId) {
      question {
        id
        title
        subTitle
        position
        options {
          id
          title
          subTitle
          canDelayOrder
          optionRef
          patientCoverageOption
          patientCoverageMessage
          opsCoverageMessage
        }
      }
      responseId
      optionRef
    }
  }
`);

export const GET_ALL_PRODUCT_SIZES = gql(`
  query GET_ALL_PRODUCT_SIZES{
    allProductSizes {
      formItemId
      formItemName
      id
      name
    }
  }
  `);

export const GET_AUTOFILL_ELIGIBLE_CATEGORIES = gql(`
  query GET_AUTOFILL_ELIGIBLE_CATEGORIES($orderNumber: String!) {
    getAutofillEligibleCategories(orderNumber: $orderNumber)
  }
`);

export const GET_ALL_FORM_ITEM_SUBSTITUTIONS = gql(`
  query FORM_ITEM_SUBSTITUTIONS($departmentId: Int!) {
    allFormItemSubstitutions(departmentId: $departmentId) {
      fromFormItem
      toFormItem
      enabled
      departmentId
    }
  }
`);

export const GET_MEDICARE_FREQUENCY_EXEMPTIONS = gql(`
  query GET_MEDICARE_FREQUENCY_EXEMPTIONS($departmentId: Int) {
    getMedicareFrequencyExemptions(departmentId: $departmentId) {
      medicareFrequencyExemptions
      medicareWeeklyFrequencyExemptions
    }
  }
  `);

export const GET_ALL_PVERIFY_PAYORS = gql(`
    query GET_ALL_PVERIFY_PAYORS {
      getAllPverifyPayors {
        id
        payorCode
        payor
      }
    }
  `);

export const GET_FREQUENT_PAYORS = gql(`
    query GET_FREQUENT_PAYORS {
      frequentPayors
    }
  `);

export const GET_CURRENT_DEPARTMENT_PRODUCTS = gql(`
  query GET_CURRENT_DEPARTMENT_PRODUCTS($departmentId: Int!, $payorName: String) {
    currentDepartmentProducts(departmentId: $departmentId, payorName: $payorName) {
      woundCareStandardItems {
        id
        name
        disableQuantityAutocalculationDefaultQuantity
        woundSizeAgnostic
        displayUnitLabel
        isBordered
        dressingCategory
        subOptions {
          optionName
          optionId
        }
        sizes {
          id
          name
        }
        frequencies {
          frequencyOfUse
          coverageDetail {
            heading
            message
            details
            key
          }
        }
      }
      ostomyStandardItems {
        id
        name
        subOptions {
          optionName
          optionId
        }
      }
      urologyStandardItems {
        id
        name
        subOptions {
          optionName
          optionId
        }
      }
      compressionStandardItems {
        wrapStandardItems{
          id
          name
          price
          subOptions {
            optionName
            optionId
          }
        }
        stockingStandardItems{
          id
          name
          price
          subOptions {
            optionName
            optionId
          }
        }
        armSleeveStandardItems{
          id
          name
          subOptions {
            optionName
            optionId
          }
        }
        braStandardItems{
          id
          name
          subOptions {
            optionName
            optionId
          }
        }
      }
      cpapStandardItems {
        id
        name
      }
      offTheShelfOrthoticsStandardItems {
        id
        name
        subcategory
      }
      nebulizerStandardItems {
        id
        name
        systemKey
      }
      ventilatorStandardItems {
        id
        name
        systemKey
      }
      customOrthoticsStandardItems {
        id
        name
        systemKey
        subcategory
      }
      prostheticsStandardItems {
        id
        name
        systemKey
        subcategory
      }
      woundSuctionStandardItems {
        id
        name
        systemKey
      }
      wheelchairsAndScootersStandardItems {
        id
        name
        systemKey
        sizes {
          id
          name
        }
      }
      diabetesStandardItems {
        id
        name
        systemKey
        sizes {
          name
        }
      }
    }
  }
`);

export const VALIDATE_OXYGEN_FORM = gql(`
  query validateOxygenForm(
    $planOfCare: PlanOfCareInput!
    $diagnoses: [DiagnosisInput!]!
  ) {
    validateOxygenForm(planOfCare: $planOfCare, diagnoses: $diagnoses) {
      fieldPath
      message
    }
  }
`);

export const SET_DEPARTMENT_FORM_ITEMS = gql(`
  mutation SET_DEPARTMENT_FORM_ITEMS(
    $departmentId: Int!
    $category: ProductCategory!
    $formItemIds: [Int!]!
  ) {
    setDepartmentFormItems(
      departmentId: $departmentId
      category: $category
      formItemIds: $formItemIds
    )
  }
`);
